import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import { 
  CircleIcon, 
  ChevronIcon2, 
  BoxIcon, 
  PlayIcon, 
  WhiteWaveIcon 
} from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';
import MadeInRussia from './MadeInRussia';

class First extends Component {
  static defaultProps = {
    bg: '/src/images/first_bg.png',
    video: '',
    poster: '',
    title: 'Производим <span class="text-white/60">надежную химическую продукцию</span> с гарантией качества',
    text: 'Выпускаем технологические, охлаждающих, противообледенительных жидкостей, дезинфицирующих средств и бытовой химии для промышленных задач. Отгружаем от 1 тонны по всей России.',
    chipText: 'Эффективное решение для вашего бизнеса',
    button1Text: 'Запросить КП',
    button2Text: 'Смотреть каталог',
    scrollText: 'Листать дальше',
    height: 1,
    plashka: 1,
    cert: false,
    data: {}
  };

  state = {
    showForm: false
  };

  // Создаем ref для основного контейнера
  constructor(props) {
    super(props);
    this.firstSectionRef = React.createRef();
  }

  // Плашка первого блока: на ПК над ней — знак «Сделано в России» (белая подложка,
  // т.к. фон тёмный), на мобильном он показывается над чипом (см. разметку ниже)
  renderPlashka = (children) => (
    <div className='w-full xl:w-[235px] mt-[20px] xl:mt-0'>
      {this.props.cert && (
        <MadeInRussia
          variant='horizontal'
          pad
          className='hidden xl:inline-block w-full max-w-[235px] mb-[15px]'
          imgClassName='w-full'
        />
      )}
      <div className='w-full backdrop-blur-[14.1px] bg-[#032432AD] rounded-[15px] p-[20px]'>
        {children}
      </div>
    </div>
  );

  // Метод для открытия формы
  openForm = () => {
    this.setState({ showForm: true });
  };

  // Метод для закрытия формы
  closeForm = () => {
    this.setState({ showForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    console.log('Form success:', message);
    if (this.props.showMessage) {
      this.props.showMessage(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    console.error('Form error:', error);
    if (this.props.showError) {
      this.props.showError(error);
    }
  };

  // Метод для прокрутки к нижней части текущего блока
  scrollToBottomOfCurrentSection = () => {
    if (this.firstSectionRef.current) {
      // Получаем позицию текущего элемента
      const elementPosition = this.firstSectionRef.current.getBoundingClientRect().top + window.pageYOffset;
      // Получаем высоту текущего элемента
      const elementHeight = this.firstSectionRef.current.offsetHeight;
      
      // Прокручиваем к нижней части элемента (elementPosition + elementHeight)
      window.scrollTo({
        top: elementPosition + elementHeight,
        behavior: 'smooth'
      });
    } else {
      // Fallback - прокрутка на высоту окна
      window.scrollBy({
        top: window.innerHeight,
        behavior: 'smooth'
      });
    }
  };

  render() {
    const { 
      bg, 
      video,
      poster,
      title, 
      text, 
      chipText, 
      button1Text, 
      button2Text, 
      scrollText,
      height,
      plashka,
      cert,
      data
    } = this.props;

    const { showForm } = this.state;

    return (
      <>
        <div 
          ref={this.firstSectionRef}
          className='relative w-full bg-center bg-cover first-section' 
          style={{ backgroundImage: `url(${bg})` }}
        >
          {video && (
            <video
              className='absolute inset-0 w-full h-full object-cover'
              src={video}
              poster={poster || undefined}
              autoPlay
              loop
              muted
              playsInline
              preload='auto'
            />
          )}
          {video && (
            <div className='absolute inset-0' style={{ backgroundColor: '#031425F2' }} />
          )}
          <div className='relative z-10 container pt-[118px] xl:pt-[78px]'>
            <div className={`flex flex-col xl:flex-row items-end justify-between mb-[41px] xl:mb-[64px]${height == 1 ? ` xl:min-h-[683px]` : ` xl:min-h-[450px]`}`}>
              <div className='w-full xl:w-auto'>
                {/* Знак «Сделано в России» на мобильном — над чипом */}
                {cert && (
                  <div className='xl:hidden flex justify-center mb-[30px]'>
                    <MadeInRussia variant='vertical' pad className='w-[110px]' imgClassName='w-full' />
                  </div>
                )}
                <div className='text-center w-full xl:text-start'>
                  <div className='px-[12px] py-[3px] xl:py-0 inline-flex items-center gap-[5px] h-auto xl:h-[35px] border border-[#797a7a] bg-white/5 rounded-full'>
                    <CircleIcon />
                    <div className='text-white text-[14px] xl:text-[16px]'>{chipText}</div>
                  </div>
                </div>
                <h1 className='text-[28px] font-medium xl:text-[46px] mt-[56px] xl:mt-[36px] text-center xl:text-start text-white tracking-[-0.04em] xl:max-w-[700px] leading-none w-full'>
                  {Parser(title)}
                </h1>
                <div className='text-[14px] xl:text-[16px] text-center xl:text-start mt-[20px] text-white/60 xl:max-w-[571px] leading-none tracking-[-0.02em]'>
                  {text}
                </div>
                <div className='mt-[56px] xl:mt-[73px] flex flex-col xl:flex-row items-center gap-[7px] w-full'>
                  {/* Кнопка Запросить КП с открытием формы */}
                  <div 
                    className='flex w-full xl:w-auto px-auto xl:px-[35px] justify-center items-center gap-[9px] h-[50px] bg-[#009EE3] text-white rounded-full cursor-pointer hover:bg-[#0082c0] transition-colors duration-300'
                    onClick={this.openForm}
                  >
                    <div className='text-[14px] xl:text-[16px]'>{button1Text}</div>
                    <ChevronIcon2 stroke="white" />
                  </div>
                  
                  {/* Кнопка Смотреть каталог */}
                  <a href={data?.katalog_link} className='flex w-full xl:w-auto px-auto xl:px-[35px] justify-center items-center gap-[9px] h-[50px] bg-white text-black rounded-full cursor-pointer hover:bg-gray-100 transition-colors duration-300'>
                    <div className='text-[14px] xl:text-[16px]'>{button2Text}</div>
                    <ChevronIcon2 stroke="black" />
                  </a>
                </div>
              </div>
              {plashka == 1 && this.renderPlashka(
                <>
                  <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[14px] w-full'>
                    <BoxIcon />
                    <div className='text-[#009EE3] text-[16px] xl:text-[18px] leading-none'>
                      <span className='text-white'>Отгрузка</span><br />до 2000 тонн в месяц
                    </div>
                  </div>
                  <div className='text-white/60 mt-[10px] text-[14px] xl:text-[16px] leading-none'>
                    Новое производство — стабильные объёмы без перебоев.
                  </div>
                </>
              )}
              {plashka == 2 && this.renderPlashka(
                <>
                  <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[14px] w-full'>
                    <svg width="22" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.94 2.62C8.12 1.49 6.81002 0.75 5.30002 0.75C2.79002 0.75 0.75 2.78999 0.75 5.29999C0.75 7.80999 2.79002 9.84998 5.30002 9.84998C6.99002 9.84998 8.56002 8.96001 9.43002 7.51001L10.76 5.29999L12.08 3.08997C12.95 1.63997 14.52 0.75 16.21 0.75C18.72 0.75 20.76 2.78999 20.76 5.29999C20.76 7.80999 18.72 9.84998 16.21 9.84998C14.71 9.84998 13.4 9.10998 12.57 7.97998" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div className='text-white/60 text-[16px] xl:text-[18px] leading-none'>
                      <span className='text-white'>Более 20 лет </span><br />опыта работы
                    </div>
                  </div>
                  <div className='text-white/60 mt-[10px] text-[14px] xl:text-[16px] leading-none'>
                    Опытные поставки, долгосрочные партнёрства и стабильность работы.
                  </div>
                </>
              )}
            </div>
            
            {/* Кнопка прокрутки с cursor-pointer и hover эффектом */}
            <div className='flex items-center justify-center'>
              <div className='relative group cursor-pointer' onClick={this.scrollToBottomOfCurrentSection}>
                <WhiteWaveIcon />
                <div className='absolute flex gap-[9px] items-center w-[196px] h-[32px] top-0 left-0 justify-center tracking-[-0.04em] group-hover:text-[#009EE3] transition-colors duration-300'>
                  <div className='text-[14px] xl:text-[16px]'>{scrollText}</div>
                  <PlayIcon className='transition-colors duration-300' />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Форма обратной связи */}
        <OffcanvasForm
          show={showForm}
          hide={this.closeForm}
          formTitle={button1Text}
          productName=""
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default First;